/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['./commonRoutingParameters', '../utils', '../validators', '../postValidators', '../converters',
    'common/parameterApplications'],
function(commonRoutingParameters, utils, validators, postValidators, converters, parameterApplications) {
    /**
     * @class Routing
     * @module Services
     */

    var routingParameters = {

        /**
             * A setter and getter for 'locations' attribute.
             *
             * Locations through which the route is calculated. The
             * following constraints apply:
             * *    At least two locations must be provided.
             * *    The first location in the sequence defines the origin and must be of type point.
             * *    The last location in the sequence defines the destination and must be of type point.
             * *    One or more optional intermediate locations (known as waypoints) may be provided:
             *      *   The maximum allowed number of waypoints is 50, reduced to 20 when computeBestOrder is true.
             *      *   A point waypoint results in an extra leg in the response, a circle waypoint does not.
             *      *   Circle waypoints cannot be used when computeBestOrder is true.
             *
             * The points or circles that will be used to calculate the route. Following input types are allowed:
             *  1. string with Colon-delimited locations. For example: '52.50931,13.42936:52.50274,13.43872'.
             *  2. array containing locations
             *     location can be defined as string,object or array
             *
             * @method locations
             * @chainable
             * @param {String|Array} [locations] This is the specified locations for route calculation.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or converted locations
             *     value if argument is omitted.
             */
        locations: {
            validator: validators.routingLocations,
            converter: converters.routingLocations,
            required: true,
            application: parameterApplications.PATH
        },
        /**
             * A setter and getter for 'maxAlternatives' attribute.
             *
             * Number of desired alternative routes to be calculated. The value provided:
             * must be an integer in the range 0-5
             * using a value greater than 0 in conjunction with computeBestOrder set to true is not allowed
             * fewer alternative routes may be returned if either fewer alternatives exist or the requested number of
             * alternatives is larger than the service can calculate Default value is 0, Maximum value is 5
             *
             * @method maxAlternatives
             * @chainable
             * @param {Number} [maxAlternatives] To restrict maximum alternative routes to be calculated.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or maxAlternatives value
             *     if argument is omitted.
             */
        maxAlternatives: {
            validator: validators.numberInInterval(0, 5)
        },

        /**
             * A setter and getter for 'instructionsType' attribute.
             *
             * If specified, guidance instructions will be returned (if available).
             *
             * Possible values:
             * * _coded_ : returns raw instruction data without human-readable messages.
             * * _text_ : returns raw instructions data with human-readable messages in plain text.
             * * _tagged_ : returns raw instruction data with tagged human-readable messages to permit formatting.
             *
             * Note that the instructionsType parameter cannot be used in conjunction with routeRepresentation=none.
             * If alternative routes are requested, instructions will be generated for each route returned.
             *
             * @method instructionsType
             * @chainable
             * @param {String} [instructionsType] If a street number is sent in along with the request, the response
             *     may include the side of the street (Left/Right) and also an offset position for that street number.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or street number value if
             *     argument is omitted.
             */
        instructionsType: {
            validator: validators.oneOfValue(['coded', 'text', 'tagged'], 'instructions type')
        },
        /* eslint-disable max-len */
        /**
             * A setter and getter for 'language' attribute.
             *
             * The language parameter determines the language of the guidance messages. It does not affect proper nouns
             * (the names of streets, plazas, etc.) It has no effect when instructionsType=coded. Allowed values are (a
             * subset of) the IETF language tags described here. The currently supported languages are listed in the
             * supported languages section:
             *
             * https://developer.tomtom.com/online-routing/online-routing-documentation-routing/calculate-route#supportedlanguages
             *
             * @method language
             * @chainable
             * @param {String} [language] The language value
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        /* eslint-enable max-len*/
        language: {
            validator: validators.routingGuidanceLanguage,
            converter: converters.routingGuidanceLanguage
        },
        /**
             * A setter and getter for 'computeBestOrder' attribute.
             *
             * Allows to reorder the route waypoints to reduce
             * the route length. Yields best results when used in conjunction with routeType shortest. Possible values:
             * *    true (compute a better order, if possible; not allowed to be used in conjunction with
             * maxAlternatives value greater than 0; not allowed to be used in conjunction with circle waypoints).
             * The response will include the optimized waypoint indices. This feature can be used with a maximum of
             * 20 route waypoints.
             * *    false (use the locations in the given order). Not allowed to be used in conjunction with
             * routeRepresentation none.
             *
             * @method computeBestOrder
             * @chainable
             * @param {Boolean} [computeBestOrder] Flag to reorder the route waypoints to reduce the route length
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Boolean} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        computeBestOrder: {
            validator: validators.bool
        },

        /**
             * A setter and getter for 'routeRepresentation' attribute.
             *
             * Specifies the representation of the set of routes provided as response. Possible values:
             * * _polyline_ includes routes in the response.
             * * _none_ includes only the optimized waypoint indices but does not include the routes in the response.
             * * _summaryOnly_ includes only route summary in the response
             *
             * This parameter value _none_ can only be used in conjunction with computeBestOrder true.
             *
             * @method routeRepresentation
             * @chainable
             * @param {String} [routeRepresentation] Allows the routing response to omit the actual route and give only
             *     the best ordered waypoints.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
        routeRepresentation: {
            validator: validators.oneOfValue(['polyline', 'none', 'summaryOnly'], 'route representation')
        },

        /**
             * A setter and getter for 'computeTravelTimeFor' attribute.
             *
             * Specifies whether to return additional travel times using different types of traffic information (none,
             * historic, live) as well as the default best-estimate travel time. Possible values:
             * * none - do not compute additional travel times,
             * * all - compute travel times for all types of traffic information. Specifying all results in the fields
             * noTrafficTravelTimeInSeconds, historicTrafficTravelTimeInSeconds and
             * liveTrafficIncidentsTravelTimeInSeconds being included in the summaries in the route response.
             *
             * @method computeTravelTimeFor
             * @chainable
             * @param {String} [computeTravelTimeFor] Setting to _all_ provides additional information regards
             * travel times.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        computeTravelTimeFor: {
            validator: validators.oneOfValue(['none', 'all'], 'compute travel time for')
        },

        /**
             * A setter and getter for 'vehicleHeading' attribute.
             *
             * The directional heading of the vehicle in degrees starting at true North and continuing in clockwise
             * direction. North is 0 degrees, east is 90 degrees, south is 180 degrees, west is 270 degrees. Possible
             * values 0-359.
             *
             * @method vehicleHeading
             * @chainable
             * @param {Number} [vehicleHeading] The angle in which the vehicle is heading.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        vehicleHeading: {
            validator: validators.integerInInterval(-1, 359)
        },

        /**
             * Sets or gets the value of the minDeviationDistance option.
             *
             * Defines at least how far **in meters** the alternative routes have to follow the reference route.
             *
             * This option cannot be used in conjunction with {{#crossLink "Routing/arriveAt:method"}}{{/crossLink}}.
             *
             * @method minDeviationDistance
             * @chainable
             * @param {Number} [newValue] Meters represented as a positive integer number
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {Number} The same service instance or the current option value if no argument was given
             */
        minDeviationDistance: {
            validator: validators.naturalInteger,
            postValidator: [
                postValidators.firstParamCannotBeUsedWithSecond('minDeviationDistance', 'arriveAt'),
                postValidators.requiresDependantParameter('minDeviationDistance', 'supportingPoints')
            ]
        },

        /**
             * Sets or gets the value of the minDeviationTime option.
             *
             * Defines at least how far **in time (seconds)** the alternative routes have to follow reference route.
             *
             * This option cannot be used in conjunction with {{#crossLink "Routing/arriveAt:method"}}{{/crossLink}}.
             *
             * @method minDeviationTime
             * @chainable
             * @param {Number} [newValue] Seconds represented as a positive integer number
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {Number} The same service instance or the current option value if no argument was given
             */
        minDeviationTime: {
            validator: validators.naturalInteger,
            postValidator: [
                postValidators.firstParamCannotBeUsedWithSecond('minDeviationTime', 'arriveAt'),
                postValidators.requiresDependantParameter('minDeviationTime', 'supportingPoints')
            ]

        },

        /* eslint-disable max-len */
        /**
             * A getter and setter for the 'supportingPoints' attribute.
             *
             * Can be used to set supporting points for constructing (or reconstructing) a route and for
             * calculating alternative routes to a base route. The provided sequence of supporting points
             * is used as input for route reconstruction.
             *
             * Pseudo examples:
             * * If the base route is A > B and we include a supporting point C, the result will be A > C > B;
             * * Supporting points can be used to reconstruct entirely a route you previously had:
             * Let's illustrate the problem. To go from A > B you received A > C > D > E > B. If later, you try to generate
             * the same route (A > B) you might get different middle points, so if you need to generate the exact same route
             * you previously had you can do something like routing().locations(A, B).supportingPoints(C, D, E)
             *
             * You can use one of the following input formats to define the supporting points:
             * * String: '52.3,4.8' or '52.3,4.8:52.37,4.87'
             * * String[]: ['52.3,4.8:52.37,4.87', '52.3,4.8:52.37,4.87']
             * * Object: {lat: 52.3, lon: 4.8} or {lat: 53.3, lng: 5.8} or {x: 53.3, y: 5.8} or {latitude: 53.3, longitude: 5.8}
             * * Object[]: [{lat: 52.3, lon: 4.8}] or [{lat: 53.3, lng: 5.8}]
             *
             * How 'Supporting Points' differ from 'Waypoints?' - Waypoints are points where the calculated route will go through, but
             * the resulting route might be different from search to search, the waypoints order might not be necessarilly respected
             * when calculating the best route, and finally, there is a limit to the number of waypoints you can use in a route calculation.
             * Supporting points can be used to contruct a previous route entirely, or parts of it, using the previous generated points,
             * meaning that there is no limit to the number of points, and the order of these points will be respected.
             *
             * For more information please refer to the [Routing API Docs](https://developer.tomtom.com/online-routing/online-routing-documentation-routing/calculate-route)
             *
             * @method supportingPoints
             * @chainable
             * @param {String|String[]|Object|Object[]} [locations] Supporting points for route calculation.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or converted locations
             *     value if argument is omitted.
             *
             * @example
             * ```js
             * tomtom.routing()
             *   .locations('52.3,4.8:52.37,4.87')
             *   .supportingPoints('52.33357,4.852')
             *   .go()
             *   .then(function(routeGeoJson) {
             *     console.log(routeGeoJson);
             *   });
             * ```
             */
        /* eslint-enable max-len */
        supportingPoints: {
            converter: converters.supportingPoints,
            application: parameterApplications.POST
        },

        /**
             * A getter and setter for the 'sectionType' attribute.
             *
             * Specifies which of the section types is reported in the route response.
             *
             * Possible values:
             * - carTrain: car or train sections in the route
             * - ferry: ferry sections
             * - tunnel: tunnel sections
             * - motorway: motorway sections
             * - tollRoad: payed toll sections
             * - pedestrian: sections which are suited for pedestrians only
             * - tollVignette: sections which require a toll vignette to be present
             * - country: returns country sub sections in the route
             * - travelMode: sections in relation to the request parameter travelMode
             * - traffic: returns traffic sub sections in the route, values include: JAM, ROAD_WORK,
             * ROAD_CLOSURE and OTHER
             *
             * Default value is travelMode.
             * @method sectionType
             * @chainable
             * @param {String[]} [sectionType] Array of section types
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String[]} The same service instance or the current option value if no argument was given
             */
        sectionType: {
            validator: validators.arrayOfValues([
                'carTrain', 'country', 'ferry', 'motorway', 'pedestrian', 'tollRoad', 'tollVignette',
                'travelMode', 'tunnel', 'traffic'
            ], 'sectionType'),
            converter: converters.arrayOfStrings
        },

        /**
             * A setter and getter for 'alternativeType' attribute.
             *
             * Specifies the alternative type of the calculated alternatives compared to the reference route.
             * Possible values are:
             *
             * * anyRoute: allow any alternative route to be returned regardless of how it compares to the reference
             * route in terms of optimality.
             * * betterRoute: returns an alternative route only if it is better than the reference route according
             * to the given planning criteria.
             *
             * Can only be used when reconstructing a route.
             *
             * @method alternativeType
             * @chainable
             * @param {String} [alternativeType] anyRoute or betterRoute value.
             * @throws {TypeError} if the given argument is not one of the accepted values described above
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
        alternativeType: {
            validator: validators.oneOfValue(['anyRoute', 'betterRoute'], 'alternativeType'),
            postValidator: postValidators.requiresDependantParameter('alternativeType', 'supportingPoints')
        }
    };

    routingParameters = utils.extend(routingParameters, commonRoutingParameters);

    return function(fieldsToSkip) {
        var result = utils.clone(routingParameters);
        if (fieldsToSkip instanceof Array) {
            fieldsToSkip.forEach(function(field) {
                delete result[field];
            });
        }

        return result;
    };
});



// WEBPACK FOOTER //
// ./services/routing/routingParameters.js